AgrimarketServices.service('typeQuotesService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
    function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

    	var SendRequest = function (configfile, callback) {
    		$http(configfile)
			    .success(function (data) {
			    	callback(data, null);
			    })
			    .error(function (data, status) {
			    	callback(data, status);
			    });
    	};

    	this.GetTypeQuotes = function (callback) {
    		var config = {
    			method: 'GET',
    			url: configurationFactory.Url['Api'] + 'TypeQuotes/GetAll'
    		};
    		SendRequest(config, callback);
    	};

    	this.GetTypeQuotesInOffers = function (callback) {
    		var config = {
    			method: 'GET',
    			url: configurationFactory.Url['Api'] + 'TypeQuotes/GetTypeQuotesInOffers'
    		};
    		SendRequest(config, callback);
    	};
    }]);